// key 和 value 参考： https://app.apifox.com/project/3871863
// 使用 云端mock 方式，token可在后台更新或删除
const token = {
  key: "apifoxToken",
  value: "koXwbje4R9e6HcWrtWiHS56tA5EeXNWW",
};
export default token;
